export default __webpack_public_path__ + "static/media/1920px-480px-Scrub-Sky-Turbines-Hero-Large.jpg.9fd87dcf.webp";